import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./FilterPanel.css";

const FilterPanel = ({ onFilterChange }) => {
  const [selectedType, setSelectedType] = useState("All");
  const [selectedRange, setSelectedRange] = useState(null);
  const [customRange, setCustomRange] = useState({ from: "", to: "" });

  const handleTypeClick = (type) => {
    if (type === "Withdrawal Fees") {
      const isActive = selectedType === "Withdrawal Fees";
      setSelectedType(isActive ? "All" : "Withdrawal Fees");
      triggerChange("All", selectedRange, customRange, !isActive, false);
      return;
    }

    if (type === "Unpaid Fees") {
      const isActive = selectedType === "Unpaid Fees";
      setSelectedType(isActive ? "All" : "Unpaid Fees");
      triggerChange("All", selectedRange, customRange, false, !isActive);
      return;
    }

    const newType = selectedType === type && type !== "All" ? "All" : type;
    setSelectedType(newType);
    triggerChange(newType, selectedRange, customRange, false);
  };

  const handleRangeClick = (range) => {
    const newRange = selectedRange === range ? null : range;
    setSelectedRange(newRange);

    if (newRange === "Custom") {
      triggerChange(selectedType, "Custom", customRange);
    } else {
      setCustomRange({ from: "", to: "" });
      triggerChange(selectedType, newRange, {});
    }
  };

  const handleCustomChange = (field, value) => {
    const updated = { ...customRange, [field]: value };
    setCustomRange(updated);
    triggerChange(selectedType, "Custom", updated);
  };

  const triggerChange = (
    type,
    range,
    custom,
    withdrawalFees = false,
    unpaidFees = false
  ) => {
    onFilterChange?.({ type, range, custom, withdrawalFees, unpaidFees });
  };

  const getClassBase = (type) => type.toLowerCase().replace(/[^a-z0-9]/g, "");

  return (
    <div className="filter-panel d-flex flex-wrap align-items-center gap-2">
      {/* Transaction Type Pills */}
      {[
        "All",
        "Transaction",
        "Withdraw",
        "Refund",
        "Withdrawal Fees",
        "Unpaid Fees",
      ].map((type) => (
        <button
          key={type}
          className={`btn btn-sm rounded-pill fw-semibold filter-btn ${
            selectedType === type
              ? `active-${getClassBase(type)}`
              : getClassBase(type)
          }`}
          onClick={() => handleTypeClick(type)}
        >
          {type}
        </button>
      ))}

      <div className="vr mx-2" />

      {/* Date Range Pills */}
      {["Today", "This Week", "This Month", "This Year", "Custom"].map(
        (range) => (
          <button
            key={range}
            className={`btn btn-sm rounded-pill fw-semibold date-btn ${
              selectedRange === range ? "active-date" : ""
            }`}
            onClick={() => handleRangeClick(range)}
          >
            {range}
          </button>
        )
      )}

      {/* Custom Range */}
      {selectedRange === "Custom" && (
        <div className="d-flex align-items-center ms-2 gap-1">
          <input
            type="date"
            value={customRange.from}
            onChange={(e) => handleCustomChange("from", e.target.value)}
            className="form-control form-control-sm"
          />
          <span className="mx-1">→</span>
          <input
            type="date"
            value={customRange.to}
            onChange={(e) => handleCustomChange("to", e.target.value)}
            className="form-control form-control-sm"
          />
        </div>
      )}
    </div>
  );
};

export default FilterPanel;
